import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark order-3 order-md-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold me-1" }, "2022 © PokerAudit")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "text-dark order-1 order-md-1 text-center d-none d-lg-block"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<img class=\"me-10 my-3\" src=\"https://php.rankopen.com/image/sponsor/wilson.png?version=1\"><img class=\"me-10 my-3\" src=\"https://php.rankopen.com/image/sponsor/babolat.png?version=1\"><img class=\"me-10 my-3\" src=\"https://php.rankopen.com/image/sponsor/nike.png?version=1\"><img class=\"me-10 my-3\" src=\"https://php.rankopen.com/image/sponsor/gatorade.png?version=1\"><img class=\"my-3\" src=\"https://php.rankopen.com/image/sponsor/pocari.png?version=1\">", 5)
const _hoisted_9 = [
  _hoisted_4
]
const _hoisted_10 = {
  key: 1,
  class: "text-dark order-1 order-md-1 text-center my-3 d-lg-none"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div><img class=\"mb-10\" src=\"https://php.rankopen.com/image/sponsor/wilson.png?version=1\"></div><div><img class=\"mb-10\" src=\"https://php.rankopen.com/image/sponsor/babolat.png?version=1\"></div><div><img class=\"mb-10\" src=\"https://php.rankopen.com/image/sponsor/nike.png?version=1\"></div><div><img class=\"mb-10\" src=\"https://php.rankopen.com/image/sponsor/gatorade.png?version=1\"></div><div><img class=\"mb-5\" src=\"https://php.rankopen.com/image/sponsor/pocari.png?version=1\"></div>", 5)
const _hoisted_16 = [
  _hoisted_11
]
const _hoisted_17 = { class: "menu menu-gray-600 menu-hover-primary fw-bold order-2 d-none" }
const _hoisted_18 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://play.google.com/store/apps/details?id=org.rankopen.quasar.app",
  target: "_blank",
  class: "menu-link px-3"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/brand-logos/google-play-store.svg",
    class: "h-20px"
  })
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://apps.apple.com/hk/app/rankopen/id1470044298",
  target: "_blank",
  class: "menu-link px-3"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/brand-logos/apple-black.svg",
    class: "h-20px"
  })
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<li class=\"menu-item\"><a href=\"https://www.facebook.com/RankOpen\" target=\"_blank\" class=\"menu-link px-3\"><img src=\"media/svg/social-logos/facebook.svg\" class=\"h-20px\"></a></li><li class=\"menu-item\"><a href=\"https://www.instagram.com/Rank.Open\" target=\"_blank\" class=\"menu-link px-3\"><img src=\"media/svg/social-logos/instagram.svg\" class=\"h-20px\"></a></li>", 2)
const _hoisted_26 = { class: "menu-item" }
const _hoisted_27 = { class: "menu-item" }
const _hoisted_28 = { class: "menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _hoisted_2,
      (_ctx.$store.state.uid == -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.$store.state.uid == -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_16))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_17, [
        (_ctx.$store.state.uid == 1)
          ? (_openBlock(), _createElementBlock("li", _hoisted_18, _hoisted_20))
          : _createCommentVNode("", true),
        (_ctx.$store.state.uid == 1)
          ? (_openBlock(), _createElementBlock("li", _hoisted_21, _hoisted_23))
          : _createCommentVNode("", true),
        _hoisted_24,
        _createElementVNode("li", _hoisted_26, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push({ name: 'contact' }))),
            class: _normalizeClass('menu-link px-2 ' + (_ctx.$route.name == 'contact' ? 'text-primary text-bolder' : ''))
          }, _toDisplayString(_ctx.$t('adsContact')), 3)
        ]),
        _createElementVNode("li", _hoisted_27, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push({ name: 'about' }))),
            class: _normalizeClass('menu-link px-2 ' + (_ctx.$route.name == 'about' ? 'text-primary text-bolder' : ''))
          }, _toDisplayString(_ctx.$t('aboutUs')), 3)
        ]),
        _createElementVNode("li", _hoisted_28, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push({ name: 'privacy' }))),
            class: _normalizeClass('menu-link px-2 '+ (_ctx.$route.name == 'privacy' ? 'text-primary text-bolder' : ''))
          }, _toDisplayString(_ctx.$t('privacy')), 3)
        ])
      ])
    ], 2)
  ]))
}